import React from "react";
import { FaCircleXmark } from "react-icons/fa6";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import { Spinner } from "react-bootstrap";
import ClipLoader from "react-spinners/ClipLoader";

const LogoutModal = ({ handleLogoutModalClose, data, onLogout, loading }) => {
  return (
    <div>
      <ModalContainer handleClose={handleLogoutModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">Confirm Logout</p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleLogoutModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div>
            {loading ? (
              <div className="d-flex justify-content-center p-2">
                <ClipLoader color="#6457c6" size="22" />
              </div>
            ) : (
              <p className="text-black">Do you want to logout ? </p>
            )}

            <div className="d-flex justify-content-center align-items-center mt-4">
              <div
                className="d-flex justify-content-center align-items-center rounded-3 p-2 mx-2 bg-dark text-white"
                role="button"
                onClick={handleLogoutModalClose}
              >
                <span className={`mx-2 d-flex`}>Cancel</span>
              </div>

              <div
                className="d-flex justify-content-center align-items-center rounded-3 p-2 mx-2 bg-danger"
                role="button"
                onClick={() => {
                  onLogout();
                }}
              >
                <span className={`mx-2 d-flex text-white`}>Logout</span>
              </div>
            </div>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default LogoutModal;
